// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import PdfViewer from './components/pdf-viewer/pdf-viewer.js';
Vue.use(PdfViewer);

// import VueAMap from 'vue-amap';
// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
//   key: '84f4fcd3bd26e948d038154a8f55c89e',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
//   // 默认高德 sdk 版本为 1.4.4
//   v: '1.4.4'
// });

import VueRouter from 'vue-router'
import $ from 'jquery'
import Cookies from 'js-cookie'
import QRCode from 'qrcode'

import vDialogs from 'v-dialogs'


import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/css/bootstrap.min.css'

import Layout from './Layout'
import Index from './pages/PageIndex'
import PrintSetting from './pages/PagePrintSetting'
import PrintMap from './pages/PagePrintMap'
import User from './pages/PageUser'
import About from './pages/PageAbout'
import Download from './pages/PageDownload'
import YS from './pages/PageYS'

Vue.use(VueRouter)

Vue.config.productionTip = false



/**
 * 站点配置
 */
Vue.SiteConfig = {
  root : '',    //  H5 history : '/web' ;
  api_domain : /127\.0\.0\.1|localhost/.test(location.href) ? '/' : 'https://web.shareprint.club/',
  env : 1,             // 1: 测试环境; 0: 正式环境

};

/**
 * 配置&初始化路由
 */
var routes = [
  { path: Vue.SiteConfig.root + '/', component: Index },
  { path: Vue.SiteConfig.root + '/index.html', component: Index },
  { path: Vue.SiteConfig.root + '/print', component: Index },
  { path: Vue.SiteConfig.root + '/print/:ext', component: Index },
  { path: Vue.SiteConfig.root + '/print-setting/:id', component: PrintSetting },
  // { path: Vue.SiteConfig.root + '/print-setting-img', component: PrintSettingImg },
  { path: Vue.SiteConfig.root + '/print-map', component: PrintMap },
  { path: Vue.SiteConfig.root + '/user', component: User },
  { path: Vue.SiteConfig.root + '/user/:status', component: User },
  // { path: Vue.SiteConfig.root + '/company-user', component: CompanyUser },
  // { path: Vue.SiteConfig.root + '/company-account-statistics', component: CompanyAccountStatistics },
  // { path: Vue.SiteConfig.root + '/company-order-statistics', component: CompanyOrderStatistics },
  // { path: Vue.SiteConfig.root + '/company-order-turnover', component: CompanyOrderTurnover },
  { path: Vue.SiteConfig.root + '/about', component: About },
  { path: Vue.SiteConfig.root + '/download', component: Download },
  { path: Vue.SiteConfig.root + '/login-out' },
  { path: Vue.SiteConfig.root + '/ys', component: YS },
  // { path: Vue.SiteConfig.root + '*', component: E404 }
];

var router = new VueRouter({
  mode: 'history',                // 启用 HTML5 History 模式. vue-router 默认 hash 模式 —— 使用 URL 的 hash 来模拟一个完整的 URL，于是当 URL 改变时，页面不会重新加载。
  routes : routes
});


// // v-uploader plugin global config
// const uploaderConfig = {
//   // file uploader service url
//   uploadFileUrl: 'http://localhost:8080/zuul/api/tool/feedback',
//   // file delete service url
//   deleteFileUrl: 'http://xxx/upload/deleteUploadFile',
//   // set the way to show upload message(upload fail message)
//   showMessage: (vue, message) => {
//     //using v-dialogs to show message
//     vue.$vDialog.alert(message, null, {messageType: 'error'});
//   }
// };
//
// // install plugin with options
// Vue.use(vUploader, uploaderConfig);
Vue.use(vDialogs);

// router.beforeHooks = function (to, from, next) {
//   console.info(from.path);
//   console.info(to.path);
//   if (to.path == '/login-out') {
//     app.loginOut();
//   } else {
//     history.pushState(null, '印箱', to.path);
//     next();
//   }
// };
// router.afterHooks = function (route) {
//   console.info(route);
// };

/* eslint-disable no-new */
var app  = new Vue({
  el: '#app',
  router,
  // pdf,
  // store,
  components: { Layout },
  template: '<Layout/>'
})




// WEBPACK FOOTER //
// ./src/main.js